import api from './api';

const bcPaymentsService = {
  generate: async (specialEventId, data) => {
    const response = await api.post(`/special-events/${specialEventId}/bc-payment`, data);
    return response.data;
  },

  getBySpecialEvent: async (specialEventId) => {
    const response = await api.get(`/special-events/${specialEventId}/bc-payment`);
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/bc-payments/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/bc-payments/${id}`, data);
    return response.data;
  },

  setPaymentDate: async (id, paymentDate) => {
    const response = await api.put(`/bc-payments/${id}/payment-date`, { paymentDate });
    return response.data;
  },

  compulsoryDonation: async (id) => {
    const response = await api.post(`/bc-payments/${id}/compulsory-donation`);
    return response.data;
  },

  addBeneficiary: async (id, data) => {
    const response = await api.post(`/bc-payments/${id}/beneficiaries`, data);
    return response.data;
  },

  toggleExcluded: async (id, beneficiaryId, excluded) => {
    const response = await api.patch(`/bc-payments/${id}/beneficiaries/${beneficiaryId}`, { excluded });
    return response.data;
  },

  removeBeneficiary: async (id, beneficiaryId) => {
    const response = await api.delete(`/bc-payments/${id}/beneficiaries/${beneficiaryId}`);
    return response.data;
  },

  payBeneficiary: async (id, beneficiaryId) => {
    const response = await api.post(`/bc-payments/${id}/beneficiaries/${beneficiaryId}/pay`);
    return response.data;
  },

  donateBeneficiary: async (id, beneficiaryId) => {
    const response = await api.post(`/bc-payments/${id}/beneficiaries/${beneficiaryId}/donate`);
    return response.data;
  },

  undoBeneficiary: async (id, beneficiaryId) => {
    const response = await api.post(`/bc-payments/${id}/beneficiaries/${beneficiaryId}/undo`);
    return response.data;
  },

  getMyShares: async () => {
    const response = await api.get('/my-bc-shares');
    return response.data;
  },

  donateMyShare: async (beneficiaryId) => {
    const response = await api.post(`/my-bc-shares/${beneficiaryId}/donate`);
    return response.data;
  },

  lookup: async (search) => {
    const response = await api.get('/bc-payments/lookup', { params: { search } });
    return response.data;
  },
};

export default bcPaymentsService;
